/**
 * 三包管理--》三包派单
*/

export default {
    custom_form_input: ["78210"], // 202506111352299403017 78210 安排派车添加输入框 https://imagecdn.ymm56.com/ymmfile/static/resource/adf06c88-fb03-41a3-bc3f-7c1b2b81eb19.png
    custom_outlets_permission: ["98801"], // 202507311343412201681 98801 三包统计时候能提取到所有网点，改成按账号实际网点权限提取，提取逻辑用新接口
    arrange_car_dispatch_calculate_sanbaoFee:['82635','99188'],//202509031501379471469公版计算三包费bug，先定制99188处理 https://imagecdn.ymm56.com/ymmfile/static/resource/1fc2016b-d2cb-42fc-aeaa-bf1f567115bb.png
}